import db from '@/services/db'

const state = () => ({
  workflowId: null,
  metaData: {
    id: '',
    statusField: '',
  },
  nodes: [],
  lines: [],
  currentNode: {},
  currentElement: {},
  counter: 0
})

const getters = {}

const mutations = {
  setWorkflow: (state, id) => state.workflowId = id,
  gotData: (state, payload) => {
    state.nodes = payload.nodes || []
    state.lines = payload.edges || []
  }, 
  updateMetaData: (state, payload) => {
    Object.keys(payload).forEach(key => {
      if (state.metaData.hasOwnProperty(key)) {
        state.metaData[key] = payload[key]
      } 
    })
  },
  setCurrentElement: (state, element) => {
    state.currentElement = element
  },
  updateNode: (state, updatedNode) => {
    const index = state.nodes.findIndex(node => node.id === updatedNode.id) 
    state.nodes.splice(index, 1, updatedNode)
  },
  setCurrentNode: (state, id) => {
    if (!id) {
      state.currentNode = {}
    } else {
      state.currentNode = state.nodes.find(node => node.id === id)
    }
  },
  addNode: (state, payload) => {
    state.nodes.push(payload)
  },
  deleteNode: (state, id) => {
    const index = state.nodes.findIndex(node => node.id === id)
    state.nodes.splice(index, 1)
    if (state.nodes.find(node => node === state.currentNode) === undefined) state.currentNode = {}
  },
  addLine: (state, payload) => {
    state.lines.push(payload)
  },
  deleteLine: (state, id) => {
    const index = state.lines.findIndex(line => line.id === id )
    state.lines.splice(index, 1)
  },
  updateLine: (state, updatedLine) => {
    const index = state.lines.findIndex(line => line.id === updatedLine.id)
    state.lines.splice(index, 1, updatedLine)
  },
  updateCounter: state => state.counter += 1
}

const actions = {
  getData: ({ commit }, id) => {
    if (id) {
      db.workflow.read(items => {
        for (const key in items) {
          if (key !== id) return

          const data = JSON.parse(items[key].data || '{}')

          commit('gotData', data)
        }
      })
    } else {
      console.warn(`Failed to load the data, id === ${id}`)
    }
  }
}

export default {
  namespaced: true, 
  state, 
  getters,
  mutations,
  actions
}